enum PunchhOloSlug {
  Punchh = 'punchh',
  PunchhProduction = 'punchh-production',
  PunchhMs = 'punchhms',
}

export { PunchhOloSlug };
